import type { AiOperationalCollaborationSignal, AiOperationalRecommendation } from '../../types/aiOperational'

type OperationalContinuityPanelProps = {
  recommendations?: AiOperationalRecommendation[]
  collaborationSignals?: AiOperationalCollaborationSignal[]
}

export const OperationalContinuityPanel = ({
  recommendations = [],
  collaborationSignals = [],
}: OperationalContinuityPanelProps) => {
  if (!recommendations.length && !collaborationSignals.length) return null
  return (
    <div className="aiOperationalContinuityPanel" aria-label="Operational continuity">
      {recommendations.length ? (
        <div>
          <span className="aiExecutionPanelLabel">Next steps</span>
          <ul>
            {recommendations.slice(0, 3).map((item) => (
              <li key={item.id}>
                <strong>{item.suggestedActionLabel}</strong>
                <span>{item.rationale}</span>
              </li>
            ))}
          </ul>
        </div>
      ) : null}
      {collaborationSignals.length ? (
        <div>
          <span className="aiExecutionPanelLabel">Collaboration</span>
          <ul>
            {collaborationSignals.slice(0, 3).map((signal) => (
              <li key={signal.id}>
                <strong>{signal.summary}</strong>
                <span>{signal.explanation}</span>
              </li>
            ))}
          </ul>
        </div>
      ) : null}
    </div>
  )
}
